/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";
import React from "react";

type SectionHeadlineProps = { headline: string; marginTop?: string };
export const SectionHeadline = ({ headline, marginTop = "32px" }: SectionHeadlineProps) => (
  <>
    <Grid sx={{ marginTop }} size={12}>
      <Typography variant="h5" sx={(theme) => ({ color: theme.palette.text.primary })}>{headline}</Typography>
    </Grid>
    <Divider sx={{ backgroundColor: "text.light", height: "1px", width: "100%" }} />
  </>
);
